import React from 'react';
import { Box } from '@mui/material';

const RichTextDisplay = ({ 
  content, 
  sx = {},
  maxLines = null,
  ...props 
}) => {
  const defaultStyles = {
    lineHeight: 1.6,
    color: '#666',
    '& p': {
      margin: '8px 0',
      '&:first-of-type': {
        marginTop: 0,
      },
      '&:last-of-type': {
        marginBottom: 0,
      }
    },
    '& div': {
      margin: '4px 0',
      '&:first-of-type': {
        marginTop: 0,
      },
      '&:last-of-type': {
        marginBottom: 0,
      }
    },
    '& ul, & ol': {
      paddingInlineStart: '20px',
      margin: '8px 0',
      '&:first-of-type': {
        marginTop: 0,
      },
      '&:last-of-type': {
        marginBottom: 0,
      }
    },
    '& li': {
      margin: '2px 0',
    },
    '& strong, & b': {
      fontWeight: 'bold',
    },
    '& em, & i': {
      fontStyle: 'italic',
    },
    '& u': {
      textDecoration: 'underline',
    },
    // Handle text alignment
    '& [style*="text-align: right"]': {
      textAlign: 'right',
    },
    '& [style*="text-align: left"]': {
      textAlign: 'left',
    },
    '& [style*="text-align: center"]': {
      textAlign: 'center',
    },
    // Limit lines if specified
    ...(maxLines && {
      display: '-webkit-box',
      WebkitLineClamp: maxLines,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    }),
    // Merge with custom styles
    ...sx
  };

  // Clean and sanitize HTML content
  const sanitizeHtml = (html) => {
    if (!html) return '';
    
    // Basic sanitization - remove potentially dangerous elements/attributes
    return html
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
      .replace(/on\w+="[^"]*"/g, '') // Remove event handlers
      .replace(/javascript:/gi, ''); // Remove javascript: urls
  };

  return (
    <Box
      sx={defaultStyles}
      dangerouslySetInnerHTML={{ 
        __html: sanitizeHtml(content) 
      }}
      {...props}
    />
  );
};

export default RichTextDisplay;